
    <!--
 * 竖版-签到领奖
 * @LastEditTime: Tue Dec 17 2024 15:43:17 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_2DMU62"  :class="[`normal`,`u_c_2DMU62`]" ><div id="u_c_5V8763"  v-html="compData.title" :class="[`${ compData.title ? 'text' : '' }`,`normal`,`u_c_5V8763`]" ></div><div id="u_c_5W8Y64"  v-html="compData.subTitle" :class="[`normal`,`u_c_5W8Y64`]" ></div><div id="u_c_96AS65"  :class="[`normal`,`u_c_96AS65`]" ><span id="u_c_DXD666"  :class="[`normal txt`,`u_c_DXD666`]" >{{`${ langData.mySignTime }:`}}</span><span id="u_c_09RI68"  :class="[`normal txt`,`u_c_09RI68`]" >{{`${ pageData.signTime }`}}</span><span id="u_c_DBKV70"  :class="[`normal txt`,`u_c_DBKV70`]" >{{`${ langData.day }`}}</span></div><div id="u_c_CZVX72"  :class="[`normal`,`u_c_CZVX72`]" ><div id="u_c_7WB473"  v-for="(signItem, signIndex) in compData.signInfo" :key="signIndex" :data-index="signItem.day" :class="[`normal sign-item btn-light`,`u_c_7WB473`]" @click="u_c_7WB473_event_W81W61($event,signIndex)"><div id="u_c_5GV674"  :class="[`normal`,`u_c_5GV674`]" >{{`${ signItem.day }${ langData.day }`}}</div><div id="u_c_5L0X76"  :style="`background-image:url(${ signItem.pic })`" :class="[`u_c_5L0X76_${signIndex}`,`normal sign-img`,`u_c_5L0X76`]" ></div><div id="u_c_GHVC77"  v-show="signItem.state == 2 || signItem.state == void 0 && signIndex == 0" :class="[`normal`,`u_c_GHVC77`]" ></div></div></div><a id="u_c_87RF78" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`normal  btn-light `,`u_c_87RF78`]" @click="u_c_87RF78_event_8J5W26($event)"><div id="u_c_EUFQ79"  :class="[`normal page-common-btn`,`u_c_EUFQ79`]" >{{`${ langData.getBtn }`}}</div></a></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"signInfo":[{"name":"签到第1个奖励\n签到第1-1个奖励\n签到第1-2个奖励\n签到第1-3个奖励","day":"1","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189607104.png"},{"name":"签到第2个奖励","day":"2","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/1675418960122.png"},{"name":"签到第3个奖励","day":"3","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189607890.png"},{"name":"签到第4个奖励","day":"4","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189609844.png"},{"name":"签到第5个奖励","day":"5","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189609538.png"},{"name":"签到第6个奖励","day":"6","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/1675418960221.png"},{"name":"签到第7个奖励","day":"7","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189606833.png"}],"subTitle":`累计签到达到以下次数，可领取活动奖励`,"title":`九考特训
签到送好礼`},"zh-CN":{"signInfo":[{"name":"加速训练5分钟*10\n研发加速5分钟*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"钻石*50\n加速训练5分钟*10\n研发加速5分钟*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"钻石*100\n加速训练5分钟*10\n研发加速5分钟*10加速建造5分钟*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"钻石*150\n爱德华·蒂奇碎片*1\n加速训练5分钟*10\n研发加速5分钟*10\n加速建造5分钟*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`活动期间，每日登入活动页面，即可完成签到，累计签到天数达到1、3、5、7天后，即可领取签到奖励；`,"title":`每日签到送不停`},"zh-TW":{"signInfo":[{"name":"加速訓練5分鐘*10研發加速5分鐘*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"鑽石*50\n加速訓練5分鐘*10\n研發加速5分鐘*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"鑽石*100\n加速訓練5分鐘*10\n研發加速5分鐘*10\n加速建造5分鐘*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"鑽石*150\n愛德華·蒂奇碎片*1\n加速訓練5分鐘*10\n研發加速5分鐘*10\n加速建造5分鐘*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`活動期間，每日登入活動頁面，即可完成簽到，累計簽到天數達到1、3、5、7天後，即可領取簽到獎勵；`,"title":`每日簽到送不停`},"en-US":{"signInfo":[{"name":"5-min Training Speedup*10\n5-min Research Speedup*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diamond*50\n5-min Training Speedup*10\n5-min Research Speedup*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diamond*100\n5-min Training Speedup*10\n5-min Research Speedup*10\n5-min Build Speedup*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diamond*150\nEdward Teach Frag*1\n5-min Training Speedup*10\n5-min Research Speedup*10\n5-min Build Speedup*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`Log in to the event page every day to sign in. Sign in for 1/3/5/7 day(s) to claim sign-in rewards.`,"title":`Daily Sign-in Reward`},"ja-JP":{"signInfo":[{"name":"訓練ブースト（5分間）*10\n研究ブースト（5分間）*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"ダイヤ*50\n訓練ブースト（5分間）*10\n研究ブースト（5分間）*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"ダイヤ*100\n訓練ブースト（5分間）*10\n研究ブースト（5分間）*10\n建造ブースト（5分間）*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"ダイヤ*150\nエドワード・ティーチの破片*1\n訓練ブースト（5分間）*10\n研究ブースト（5分間）*10\n建造ブースト（5分間）*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`イベント期間中、毎日イベント画面からログインするとサインインが完了します。合計サインイン日数が1、3、5、7日に到達すると、対応するボーナスを受け取れます。`,"title":`毎日ログイン　ボーナス続々`},"ko-KR":{"signInfo":[{"name":"훈련 5분 가속*10\n개발 5분 가속*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"다이아*50\n훈련 5분 가속*10\n개발 5분 가속*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"다이아*100\n훈련 5분 가속*10\n개발 5분 가속*10\n건설 5분 가속*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"다이아*150\n에드워드 티치*1\n훈련 5분 가속*10\n개발 5분 가속*10\n건설 5분 가속*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`이벤트 기간 동안 이벤트 페이지에 매일 접속하여 출석을 완료하면, 누적 출석 일수 1, 3, 5, 7일마다 출석 보상을 획득합니다.`,"title":`매일 출석하면 선물이 팡팡`},"th-TH":{"signInfo":[{"name":"เร่งสปีดฝึก5นาที*10\nเร่งสปีดการวิจัย5นาที*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"เพชร*50\nเร่งสปีดฝึก5นาที*10\nเร่งสปีดการวิจัย5นาที*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"เพชร*100\nเร่งสปีดฝึก5นาที*10\nเร่งสปีดการวิจัย5นาที*10\nเร่งสปีดสร้าง5นาที*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"เพชร*150\nเอ็ดเวิร์ด ทีช*1\nเร่งสปีดฝึก5นาที*10\nเร่งสปีดการวิจัย5นาที*10\nเร่งสปีดสร้าง5นาที*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`ทุกวันที่เปิดหน้ากิจกรรมในช่วงกิจกรรม ก็จะถือว่าเช็คอินเสร็จสิ้น เมื่อเช็คอินสะสมครบ 1, 3, 5 และ 7 วัน จะรับรางวัลเช็คอินได้`,"title":`เช็คอินแล้ว รับรางวัลทันที`},"vi-VN":{"signInfo":[{"name":"Tăng tốc huấn luyện 5 phút*10\nTăng tốc nghiên cứu 5 phút*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Kim Cương*50\nTăng tốc huấn luyện 5 phút*10\nTăng tốc nghiên cứu 5 phút*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Kim Cương*100\nTăng tốc huấn luyện 5 phút*10\nTăng tốc nghiên cứu 5 phút*10\nTăng tốc xây 5 phút*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Kim Cương*150\nEdward Teach Frag*1\nTăng tốc huấn luyện 5 phút*10\nTăng tốc nghiên cứu 5 phút*10\nTăng tốc xây 5 phút*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`Trong thời gian hoạt động, đăng nhập giao diện hoạt động mỗi ngày là hoàn thành điểm danh, sau khi điểm danh đến 1, 3, 5, 7 ngày là được nhận thưởng điểm danh;`,"title":`Điểm Danh Hàng Ngày Nhận Quà Liền Tay`},"de-DE":{"signInfo":[{"name":"5 Min Training Beschleunigen*10\n5 Min Forschung Beschleunigen*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diamant*50\n5 Min Training Beschleunigen*10\n5 Min Forschung Beschleunigen*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diamant*100\n5 Min Training Beschleunigen*10\n5 Min Forschung Beschleunigen*10\n5 Min Bau Beschleunigen*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diamant*150\nEdward Teach Frag*1\n5 Min Training Beschleunigen*10\n5 Min Forschung Beschleunigen*10\n5 Min Bau Beschleunigen*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`Logge dich jeden Tag auf der Eventseite an, um dich anzumelden. Melde dich für 1/3/5/7 Tag(e) an, um Anmeldebelohnungen zu erhalten.`,"title":`Tägliche Anmeldebelohnung`},"fr-FR":{"signInfo":[{"name":"Accélération entraînement 5-min*10\nAccélération recherche 5-min*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diamant*50\nAccélération entraînement 5-min*10\nAccélération recherche 5-min*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diamant*100\nAccélération entraînement 5-min*10\nAccélération recherche 5-min*10\nAccélération bâtiment 5-min*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diamant*150\nEdward Teach Frag*1\nAccélération entraînement 5-min*10\nAccélération recherche 5-min*10\nAccélération bâtiment 5-min*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`Connectez-vous à la page de l'événement tous les jours pour vous connecter. Connectez-vous pendant 1/3/5/7 jour(s) pour réclamer les récompenses de connexion.`,"title":`Récompense de Connexion Quotidienne`},"ru-RU":{"signInfo":[{"name":"Ускорение Обучения (5 мин.)*10\nУскорение Исследования (5 мин.)*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Алмаз*50\nУскорение Обучения (5 мин.)*10\nУскорение Исследования (5 мин.)*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Алмаз*100\nУскорение Обучения (5 мин.)*10\nУскорение Исследования (5 мин.)*10\nУскорение Строительства (5 мин.)*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Алмаз*150\nEdward Teach Frag*1\nУскорение Обучения (5 мин.)*10\nУскорение Исследования (5 мин.)*10\nУскорение Строительства (5 мин.)*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`Заходите на страницу события каждый день, чтобы заработать посещение. Посещайте в течение 1/3/5/7 дн. подряд, чтобы получить награду за вход.`,"title":`Награда за Ежедневный Вход`},"es-ES":{"signInfo":[{"name":"5 min de Aceleración de Entrenamiento*10\n5 min de Aceleración de investigación*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diamante*50\n5 min de Aceleración de Entrenamiento*10\n5 min de Aceleración de investigación*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diamante*100\n5 min de Aceleración de Entrenamiento*10\n5 min de Aceleración de investigación*10\n5 min de Aceleración de Construcción*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diamante*150\nEdward Teach Frag*1\n5 min de Aceleración de Entrenamiento*10\n5 min de Aceleración de investigación*10\n5 min de Aceleración de Construcción*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`Ingresa a la página del evento todos los días para registrarte. Regístrate por 1/3/5/7 día(s) para reclamar las recompensas de inicio de sesión.`,"title":`Recompensa de inscripción diaria`},"pt-PT":{"signInfo":[{"name":"5 min de Aceleração de Treinamento*10\n5 min de aceleração da Pesquisa*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diamante*50\n5 min de Aceleração de Treinamento*10\n5 min de aceleração da Pesquisa*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diamante*100\n5 min de Aceleração de Treinamento*10\n5 min de aceleração da Pesquisa*10\n5 minutos de Aceleração de Construção*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diamante*150\nEdward Teach Frag*1\n5 min de Aceleração de Treinamento*10\n5 min de aceleração da Pesquisa*10\n5 minutos de Aceleração de Construção*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`Faça login na página do evento todos os dias para fazer entrar. Faça login por 1/3/5/7 dia(s) para reivindicar recompensas de login.`,"title":`Recompensa de Login Diário`},"it-IT":{"signInfo":[{"name":"Velocizz. Addestramento 5-min*10\nVelocizz. Ricerca 5-min*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diamante*50\nVelocizz. Addestramento 5-min*10\nVelocizz. Ricerca 5-min*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diamante*100\nVelocizz. Addestramento 5-min*10\nVelocizz. Ricerca 5-min*10\nVelocizz. Costruzione 5-min*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diamante*150\nEdward Teach Frag*1\nVelocizz. Addestramento 5-min*10\nVelocizz. Ricerca 5-min*10\nVelocizz. Costruzione 5-min*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`Accedi alla pagina dell'evento ogni giorno per accedere. Accedi per 1/3/5/7 giorno/i per richiedere i premi di accesso.`,"title":`Ricompensa Accesso Giornaliero`},"tr-TR":{"signInfo":[{"name":"5-dk Eğitim Hızlandırma*10\n5-dk Araştırma Hızlandırma*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Elmas*505-dk Eğitim Hızlandırma*105-dk Araştırma Hızlandırma*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Elmas*100\n5-dk Eğitim Hızlandırma*10\n5-dk Araştırma Hızlandırma*10\n5-dk İnşa Hızlandırma*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Elmas*150\nEdward Teach Frag*1\n5-dk Eğitim Hızlandırma*10\n5-dk Araştırma Hızlandırma*10\n5-dk İnşa Hızlandırma*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`Oturum açmak için her gün etkinlik sayfasına giriş yap. Oturum ödüllerini talep etmek için 1/3/5/7 gün giriş yap.`,"title":`Günlük Giriş Ödülü`},"pl-PL":{"signInfo":[{"name":"5-min. Przyśpieszenie Szkolenia*10\n5-min. Przyśpieszenie Badań*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diament*505-min. Przyśpieszenie Szkolenia*105-min. Przyśpieszenie Badań*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diament*100\n5-min. Przyśpieszenie Szkolenia*10\n5-min. Przyśpieszenie Badań*10\n5-min. Przyśpieszenie Budowania*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diament*150\nEdward Teach Frag*1\n5-min. Przyśpieszenie Szkolenia*10\n5-min. Przyśpieszenie Badań*10\n5-min. Przyśpieszenie Budowania*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`Zaloguj się na stronie wydarzenia każdego dnia, aby zaliczyć dzienne logowanie. Zaloguj się przez 1/3/5/7 dni, aby odebrać nagrody za logowanie.`,"title":`Nagroda dziennego logowania`},"id-ID":{"signInfo":[{"name":"Speed up Training 5 menit*10\nSpeed up R&D 5 menit*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diamond*50Speed up Training 5 menit*10Speed up R&D 5 menit*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diamond*100\nSpeed up Training 5 menit*10\nSpeed up R&D 5 menit*10\nSpeed up Pembangunan 5 menit*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diamond*150\nEdward Teach Frag*1\nSpeed up Training 5 menit*10\nSpeed up R&D 5 menit*10\nSpeed up Pembangunan 5 menit*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":`Log elke dag in op de event pagina om je aan te melden. Meld je gedurende 1/3/5/7 dag(en) aan om beloningen te claimen.`,"title":`Dagelijks Inlog Beloning`},"ar-SA":{"signInfo":[{"name":"تسريع التدريب 5 دقائق*10\nتسريع الأبحاث 5 دقائق*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"الماس*50\nتسريع التدريب 5 دقائق\nتسريع الأبحاث 5 دقائق","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"الماس*100\nتسريع التدريب 5 دقائق\nتسريع الأبحاث 5 دقائق\nتسريع البناء 5 دقائق","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"الماس*150\nإدوارد تيتش*1\nتسريع التدريب 5 دقائق\nتسريع الأبحاث 5 دقائق\nتسريع البناء 5 دقائق","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852975531789.png"}],"subTitle":``,"title":`Hadiah Sign-In Harian`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '签到领奖';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const showTips = inject("showTips", (txt,code) => {})
const showGetSucc = inject("showGetSucc", (type, pic,name) => {})
const listData = inject("listData", {})
const giftInfo = inject("giftInfo", {})

const curPlatform = pagePlatform;

const init = () => {
  compData.signInfo.forEach((item) => {
    item.state = 0
  })
}

watch(
  () => listData,
  (value) => {
    if (value && value.signList) {
      let confList = _.cloneDeep(compData.signInfo)
      compData.signInfo = []
      value.signList.forEach((item, index) => {
        if(confList[index]){
          compData.signInfo.push({
            pic: confList[index].pic,
            state: item.send_status,
            day: item.sign_day,
            name:confList[index].name
          })}
      })
      giftInfo.signInAward = compData.signInfo
    }
  },
  { deep: true }
)

init()

const canClickSign = ref(true)
const signDay = async (day, index) => {
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=signInAward`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=signInAward`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=signInAward`,
  }
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      sign_day: +day,
      language:curLang
    }),
  })
  if (res.result == 1) {
    compData.signInfo[index].state = 2;
    let curGiftName = res.data.send_type == 'sendSerial' ? res.data.send_value:compData.signInfo[index].name;
    showGetSucc(res.data.send_type, compData.signInfo[index].pic,curGiftName)
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")),res.code)
  }
  return res.result == 1
}

;
      // 签到item的click事件
      const u_c_7WB473_event_W81W61= async (e,index)=>{
        try {pageData.seeGift = [compData.signInfo[index]]
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 签到可领按钮的click事件
      const u_c_87RF78_event_8J5W26= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
if (!canClickSign.value) return;
canClickSign.value = false;
window.activityDataLayer.push({
  eventName: 'click_button',
  eventType: `领取签到奖励`,
  gameId: pageData.gameId,
  aid: pageData.pageId
});
let curIndex = compData.signInfo.findIndex(item => item.state == 1);
if (~curIndex) {
  await signDay(compData.signInfo[curIndex].day, curIndex);
} else {
  let finishIndex = compData.signInfo.findIndex(item => item.state == 2);
  showTips(
    getLangTxt(
      finishIndex == compData.signInfo.length - 1 ? '-20001' : '-10010',
      getLangTxt('common')
    ),
    ''
  );
}
canClickSign.value = true;} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.default{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.default{
.u_c_DXD666.normal{
position:relative;

}
}.default{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.default{
.u_c_DBKV70.normal{
position:relative;

}
}.default{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.default{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.default{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.default{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.default{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.default{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.default{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.zh-CN{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.zh-CN{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.zh-CN{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-CN{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.zh-CN{
.u_c_DXD666.normal{
position:relative;

}
}.zh-CN{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.zh-CN{
.u_c_DBKV70.normal{
position:relative;

}
}.zh-CN{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.zh-CN{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.zh-CN{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.zh-CN{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.zh-CN{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.zh-CN{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.zh-CN{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.zh-TW{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.zh-TW{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.zh-TW{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-TW{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.zh-TW{
.u_c_DXD666.normal{
position:relative;

}
}.zh-TW{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.zh-TW{
.u_c_DBKV70.normal{
position:relative;

}
}.zh-TW{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.zh-TW{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.zh-TW{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.zh-TW{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.zh-TW{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.zh-TW{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.zh-TW{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.en-US{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.en-US{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.en-US{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.en-US{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.en-US{
.u_c_DXD666.normal{
position:relative;

}
}.en-US{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.en-US{
.u_c_DBKV70.normal{
position:relative;

}
}.en-US{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.en-US{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.en-US{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.en-US{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.en-US{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.en-US{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.en-US{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.ja-JP{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ja-JP{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.ja-JP{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ja-JP{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.ja-JP{
.u_c_DXD666.normal{
position:relative;

}
}.ja-JP{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.ja-JP{
.u_c_DBKV70.normal{
position:relative;

}
}.ja-JP{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.ja-JP{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.ja-JP{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.ja-JP{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.ja-JP{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.ja-JP{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.ja-JP{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.ko-KR{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ko-KR{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.ko-KR{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ko-KR{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.ko-KR{
.u_c_DXD666.normal{
position:relative;

}
}.ko-KR{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.ko-KR{
.u_c_DBKV70.normal{
position:relative;

}
}.ko-KR{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.ko-KR{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.ko-KR{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.ko-KR{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.ko-KR{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.ko-KR{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.ko-KR{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.th-TH{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.th-TH{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.th-TH{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.th-TH{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.th-TH{
.u_c_DXD666.normal{
position:relative;

}
}.th-TH{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.th-TH{
.u_c_DBKV70.normal{
position:relative;

}
}.th-TH{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.th-TH{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.th-TH{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.th-TH{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.th-TH{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.th-TH{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.th-TH{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.vi-VN{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.vi-VN{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.vi-VN{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.vi-VN{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.vi-VN{
.u_c_DXD666.normal{
position:relative;

}
}.vi-VN{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.vi-VN{
.u_c_DBKV70.normal{
position:relative;

}
}.vi-VN{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.vi-VN{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.vi-VN{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.vi-VN{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.vi-VN{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.vi-VN{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.vi-VN{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.de-DE{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.de-DE{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.de-DE{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.de-DE{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.de-DE{
.u_c_DXD666.normal{
position:relative;

}
}.de-DE{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.de-DE{
.u_c_DBKV70.normal{
position:relative;

}
}.de-DE{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.de-DE{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.de-DE{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.de-DE{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.de-DE{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.de-DE{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.de-DE{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.fr-FR{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.fr-FR{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.fr-FR{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.fr-FR{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.fr-FR{
.u_c_DXD666.normal{
position:relative;

}
}.fr-FR{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.fr-FR{
.u_c_DBKV70.normal{
position:relative;

}
}.fr-FR{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.fr-FR{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.fr-FR{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.fr-FR{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.fr-FR{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.fr-FR{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.fr-FR{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.ru-RU{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ru-RU{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.ru-RU{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ru-RU{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.ru-RU{
.u_c_DXD666.normal{
position:relative;

}
}.ru-RU{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.ru-RU{
.u_c_DBKV70.normal{
position:relative;

}
}.ru-RU{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.ru-RU{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.ru-RU{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.ru-RU{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.ru-RU{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.ru-RU{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.ru-RU{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.es-ES{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.es-ES{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.es-ES{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.es-ES{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.es-ES{
.u_c_DXD666.normal{
position:relative;

}
}.es-ES{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.es-ES{
.u_c_DBKV70.normal{
position:relative;

}
}.es-ES{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.es-ES{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.es-ES{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.es-ES{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.es-ES{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.es-ES{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.es-ES{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.pt-PT{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.pt-PT{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.pt-PT{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.pt-PT{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.pt-PT{
.u_c_DXD666.normal{
position:relative;

}
}.pt-PT{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.pt-PT{
.u_c_DBKV70.normal{
position:relative;

}
}.pt-PT{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.pt-PT{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.pt-PT{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.pt-PT{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.pt-PT{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.pt-PT{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.pt-PT{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.it-IT{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.it-IT{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.it-IT{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.it-IT{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.it-IT{
.u_c_DXD666.normal{
position:relative;

}
}.it-IT{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.it-IT{
.u_c_DBKV70.normal{
position:relative;

}
}.it-IT{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.it-IT{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.it-IT{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.it-IT{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.it-IT{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.it-IT{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.it-IT{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.tr-TR{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.tr-TR{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.tr-TR{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.tr-TR{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.tr-TR{
.u_c_DXD666.normal{
position:relative;

}
}.tr-TR{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.tr-TR{
.u_c_DBKV70.normal{
position:relative;

}
}.tr-TR{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.tr-TR{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.tr-TR{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.tr-TR{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.tr-TR{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.tr-TR{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.tr-TR{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.pl-PL{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.pl-PL{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.pl-PL{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.pl-PL{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.pl-PL{
.u_c_DXD666.normal{
position:relative;

}
}.pl-PL{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.pl-PL{
.u_c_DBKV70.normal{
position:relative;

}
}.pl-PL{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.pl-PL{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.pl-PL{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.pl-PL{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.pl-PL{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.pl-PL{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.pl-PL{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.id-ID{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.id-ID{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.id-ID{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.id-ID{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.id-ID{
.u_c_DXD666.normal{
position:relative;

}
}.id-ID{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.id-ID{
.u_c_DBKV70.normal{
position:relative;

}
}.id-ID{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.id-ID{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.id-ID{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.id-ID{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.id-ID{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.id-ID{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.id-ID{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}.ar-SA{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264272-65.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ar-SA{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.ar-SA{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ar-SA{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.ar-SA{
.u_c_DXD666.normal{
position:relative;

}
}.ar-SA{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.ar-SA{
.u_c_DBKV70.normal{
position:relative;

}
}.ar-SA{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.ar-SA{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264368-1.png);
background-size:contain;
width:3.04rem;
height:3.28rem;

}
}.ar-SA{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#FFFFFF;
text-align:center;
margin:auto;
margin-top:0.15rem;

}
}.ar-SA{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.ar-SA{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.ar-SA{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.65rem;
height:1.69rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.ar-SA{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.43rem;
font-weight:bold;

}
}
</style>
